import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, createStyles } from '@material-ui/core/styles';
// import { SvgIconProps } from '@material-ui/core/SvgIcon'
import List from '@material-ui/core/List';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Collapse from '@material-ui/core/Collapse';
import IconExpandLess from '@material-ui/icons/ExpandLess';
import IconExpandMore from '@material-ui/icons/ExpandMore';
import NavMenuItemComponent from './NavMenuItemComponent';
// React runtime PropTypes
export const NavMenuItemPropTypes = {
    name: PropTypes.string.isRequired,
    path: PropTypes.string,
    Icon: PropTypes.elementType,
    items: PropTypes.array,
};
const NavMenuItem = props => {
    const { name, path, Icon, items = [] } = props;
    const classes = useStyles();
    const isExpandable = items && items.length > 0;
    const [open, setOpen] = React.useState(false);

    function handleClick() {
        setOpen(!open);
    }

    const MenuItemRoot = (

        <NavMenuItemComponent className={classes.menuItem} link={path} onClick={handleClick}>
            {/* Display an icon if any */}
            {!!Icon && (
                <ListItemIcon className={classes.menuItemIcon}>
                    <Icon />
                </ListItemIcon>
            )}
            <ListItemText primary={name} inset={!Icon} />
            {/* Display the expand menu if the item has children */}
            {isExpandable && !open && <IconExpandMore />}
            {isExpandable && open && <IconExpandLess />}
        </NavMenuItemComponent>
    );


    const MenuItemChildren = isExpandable ? (<Collapse in={open} timeout="auto" unmountOnExit>
        <Divider />
        <List component="div" disablePadding>
            {items.map((item, index) => (
                <NavMenuItem {...item} key={index} />
            ))}
        </List>
    </Collapse>) : null;


    return (
        <>
            {MenuItemRoot}
            {MenuItemChildren}
        </>);
};
const useStyles = makeStyles(theme => createStyles({
    // menuItem: {
    //     '&.active': {
    //         background: 'rgba(0, 0, 0, 0.08)',
    //         '& .MuiListItemIcon-root': {
    //             color: '#fff',
    //         },
    //     },
    // },
    menuItemIcon: {
        color: '#00a650',
    },
}));
export default NavMenuItem;
